import React, { useState, useContext } from "react";
import {
    EmptyStateContainer,
    CartContainer,
    StyledEmployeeTitle,
    StyledEmployeeContainer,
    StyledEmployeeSubTitle,
    CartItemsDiv,
    HeightFillerDiv,
    ContainerFlex,
    StyledInfoIcon,
    EmployeeRowContainer,
    TooltipTitle,
    CenteringFlex,
} from "./cart.styled";
import CreditLimit from "@/components/credit-limit";
import AccountSelector from "@/components/account-selector";
import PaymentMethod from "@/components/payment-method";
import { accountTypes } from "@/constants";
import HtmlTooltip from "@/components/htmlTooltip";
import AlertContainer from "@/components/alert-container";
import CartImg from "@/assets/bgShoppingCart.jpg";
import { AppContext } from "@/contexts/AppContext";
import { useMainPageContext } from "@/contexts/MainPageContext";
import CartItem from "./cartItem";
import CartSubTotal from "./cartSubTotal";
import { truncateString } from "@/helper/common";
import { GeneralPromotionSelect } from "../general-promotion-select";

export default function Cart({ benefits, employeeBalance, buttonText }){
    const [showCredit, setShowCredit] = useState(false);
    const {
        selectedProducts,
        selectedPaymentMethod,
        setSelectedPaymentMethod,
        selectedAccountTypeId,
        setSelectedAccountTypeId,
        openNotEnoughBalanceMessage,
        cartAlert,
        handleCloseCartAlert,
    } = useMainPageContext();
    const { subTotal, selectedEmployee } = useContext(AppContext);
    const isCompanyAccount = selectedEmployee?.companyAccount;
    const employeeName = selectedEmployee?.name || "";
    const employeeId = selectedEmployee?.employeeCode;

    return (
        <CartContainer>
            {!employeeName ? (
                <EmptyStateContainer src={CartImg} />
            ) : (
                <>
                    <StyledEmployeeContainer backgroundColor={selectedAccountTypeId === 1 ? "#6ec4e8" : "#ff8d6a"}>
                        <EmployeeRowContainer>
                            <div>
                                <StyledEmployeeTitle>{truncateString(employeeName,38)}</StyledEmployeeTitle>
                                <StyledEmployeeSubTitle>{employeeId}</StyledEmployeeSubTitle>
                            </div>
                            <ContainerFlex>
                                <StyledEmployeeSubTitle>{employeeBalance}</StyledEmployeeSubTitle>
                                <StyledInfoIcon onClick={() => setShowCredit(!showCredit)} />
                            </ContainerFlex>
                        </EmployeeRowContainer>
                        {isCompanyAccount && (
                            <AccountSelector
                                selectedAccountTypeId={selectedAccountTypeId}
                                setSelectedAccountTypeId={setSelectedAccountTypeId}
                            />
                        )}
                    </StyledEmployeeContainer>
                    {selectedAccountTypeId === accountTypes.employee && (
                        <PaymentMethod
                            selectedPaymentMethod={selectedPaymentMethod}
                            setSelectedPaymentMethod={setSelectedPaymentMethod}
                        />
                    )}
                    <CartItemsDiv isEmployeeAccount={selectedAccountTypeId === accountTypes.employee}>
                        {showCredit && (
                            <CreditLimit balances={benefits?.benefits || null} close={() => setShowCredit(false)} />
                        )}
                        <HeightFillerDiv>
                            <AlertContainer
                                setVisible={
                                    selectedProducts?.length > 0 && cartAlert?.function && cartAlert?.text
                                        ? true
                                        : false
                                }
                                onAccept={cartAlert.function}
                                onClose={handleCloseCartAlert}
                                changeText={cartAlert.text}
                            />
                            {selectedProducts.map((product) => (
                                <CartItem product={product} key={product.id} />
                            ))}
                        </HeightFillerDiv>
                       {selectedProducts.length > 0 && selectedAccountTypeId === accountTypes.employee &&  <GeneralPromotionSelect />}
                        {subTotal ? (
                            <CartSubTotal actionButtonText={buttonText} />
                        ) : (
                            <CenteringFlex>
                                <div>
                                    <HtmlTooltip
                                        open={openNotEnoughBalanceMessage}
                                        placement="top"
                                        title={<TooltipTitle>No hay suficiente balance</TooltipTitle>}
                                    >
                                        <div style={{ marginLeft: "-20px" }} />
                                    </HtmlTooltip>
                                </div>
                            </CenteringFlex>
                        )}
                    </CartItemsDiv>
                </>
            )}
        </CartContainer>
    );
}; 